var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWineDetailsRegionV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.6562C21.9899 27.6562 27.6562 21.9899 27.6562 15C27.6562 8.01015 21.9899 2.34375 15 2.34375C8.01015 2.34375 2.34375 8.01015 2.34375 15C2.34375 21.9899 8.01015 27.6562 15 27.6562Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9588 2.49432L15 4.45311L16.4063 5.85936V6.56249H15L12.8906 7.26561L12.1875 9.37499L12.8906 10.0781H13.5938L15 8.67186",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 9.375L11.1328 10.4297H10.4297L9.375 11.4844V13.2422H13.2422L14.2969 12.1875H15.3516L16.4062 13.2422L17.4609 12.1875L18.1641 15.7031L19.5703 17.8125H20.9766L22.0312 15.7031L20.9766 14.6484V13.5938L22.0312 12.5391H23.0859L25.1953 14.6484H27.6516",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02344 8.67188L10.0781 7.61719V6.21094",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4342 27.6492L13.5938 25.1953L12.8906 22.3828L11.4844 21.6797L8.67188 20.9766L7.96875 18.8672V17.4609L10.0781 15.3516H12.5391L13.8023 16.6148L14.8014 15.6158H15.5045L18.317 19.8346H20.4264L18.317 21.9439V23.3502L16.9107 24.7564L15.9563 27.6205",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineDetailsRegionV2);
export default __webpack_public_path__ + "static/media/wine-details-region-V2.7908b550b36a8b62b9ae766d1e22796c.svg";
export { ForwardRef as ReactComponent };